import React, { useState, useEffect } from "react";
import { api } from "../api";

export default function Dashboard({ onOpenUpload, onViewCampaign, onOpenStatus }) {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCampaigns = async () => {
    try {
      const res = await api.getCampaigns();
      setCampaigns(res.campaigns || []);
    } catch (err) {
      alert("Failed to load campaigns: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const total = campaigns.length;
  const uploaded = campaigns.filter(c => c.status === "Uploaded").length;
  const sending = campaigns.filter(c => c.status === "Sending").length;
  const completed = campaigns.filter(c => c.status === "Completed").length;

  const handleStartSend = async (campaign) => {
    if (!window.confirm(`Are you sure you want to send all ${campaign.total_records} messages for "${campaign.campaign_name}" sequentially?`)) return;
    try {
      api.sendCampaign(campaign.campaign_id); // Fire and forget from client perspective
      onOpenStatus(campaign.campaign_id);
    } catch (err) {
      alert("Error starting campaign: " + err.message);
    }
  };

  return (
    <div>
      <div className="card-grid">
        <div className="card"><div className="card-label">Total Campaigns</div><div className="card-value">{total}</div></div>
        <div className="card"><div className="card-label">Uploaded</div><div className="card-value">{uploaded}</div></div>
        <div className="card"><div className="card-label">Sending</div><div className="card-value">{sending}</div></div>
        <div className="card"><div className="card-label">Completed</div><div className="card-value">{completed}</div></div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
        <h2>Campaign Management</h2>
        <button className="btn btn-primary" onClick={onOpenUpload}>+ Upload New Campaign</button>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Campaign Name</th>
              <th>Upload Date & Time</th>
              <th>Total</th>
              <th>Sent</th>
              <th>Failed</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="7" style={{ textAlign: "center" }}>Loading campaigns...</td></tr>
            ) : campaigns.length === 0 ? (
              <tr><td colSpan="7" style={{ textAlign: "center" }}>No campaigns uploaded yet.</td></tr>
            ) : (
              campaigns.map((c) => (
                <tr key={c.campaign_id}>
                  <td style={{ fontWeight: 600 }}>{c.campaign_name}</td>
                  <td>{new Date(c.upload_timestamp).toLocaleString()}</td>
                  <td>{c.total_records}</td>
                  <td style={{ color: "var(--success)" }}>{c.sent_count}</td>
                  <td style={{ color: "var(--danger)" }}>{c.failed_count}</td>
                  <td><span className={`badge badge-${c.status}`}>{c.status}</span></td>
                  <td>
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                      <button className="btn btn-outline" onClick={() => onViewCampaign(c.campaign_id)}>View</button>
                      <button 
                        className="btn btn-primary" 
                        disabled={c.status === "Completed" || c.status === "Sending"} 
                        onClick={() => handleStartSend(c)}
                      >
                        Send
                      </button>
                      <button className="btn btn-outline" onClick={() => onOpenStatus(c.campaign_id)}>Status</button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}